import { render, staticRenderFns } from "./clientDetailsRenderer.vue?vue&type=template&id=4315cc0f&scoped=true&"
import script from "./clientDetailsRenderer.vue?vue&type=script&lang=js&"
export * from "./clientDetailsRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4315cc0f",
  null
  
)

export default component.exports